import React from "react";
import {
  getServiceRequestListClientEmailStage,
  shortLabelForClientEmailStage,
} from "../../utils/adminListEmailStage";

/**
 * Client email **stage** for the service-requests table: not sent → sent → client replied.
 * @see getServiceRequestListClientEmailStage
 */
export function ServiceRequestEmailStageBadge({ row }) {
  const { stage, title, outboundPending } =
    getServiceRequestListClientEmailStage(row);

  if (stage === "none") {
    return (
      <span className="admin-dash__list-email-stage-dash" title={title}>
        —
      </span>
    );
  }

  const label = shortLabelForClientEmailStage(stage);
  const mod =
    stage === "not_sent"
      ? "admin-dash__email-stage-pill--not-sent"
      : stage === "sent"
        ? "admin-dash__email-stage-pill--sent"
        : "admin-dash__email-stage-pill--replied";

  const aria =
    outboundPending && stage === "not_sent"
      ? `${label}, sending`
      : label;

  return (
    <div className="admin-dash__email-stage-line">
      <span
        className={`admin-dash__email-stage-pill ${mod}`}
        title={title}
        role="status"
        aria-label={aria}
      >
        {label}
      </span>
      {outboundPending && stage === "not_sent" ? (
        <span
          className="admin-dash__email-stage-sending"
          title="Outbound queued — SMTP not finished yet"
        >
          Sending…
        </span>
      ) : null}
    </div>
  );
}
